import React, { useEffect } from 'react';
import $ from 'jquery';
window.$ = window.jQuery = $;

// Usa require en lugar de import
require('owl.carousel/dist/assets/owl.carousel.css');
require('owl.carousel/dist/assets/owl.theme.default.css');
require('owl.carousel');


const SliderHome = () => {
  useEffect(() => {
    $('.owl-carousel').owlCarousel({
      items: 1,
      loop: true,
      nav: true,
      dots: true,
      autoplay: true,
      autoplayTimeout: 4000,
      smartSpeed: 800,
    });

  // Esta parte se encarga de limpiar el carrusel al desmontar el componente
  return () => {
    $('.owl-carousel').trigger('destroy.owl.carousel');
  };
}, []);

  return (
    <section className="full-screen top-position1 p-0">
      <div className="slider-fade2 owl-carousel owl-theme w-100 min-vh-100">
        {/* Slide 1 */}
        <div
          className="item bg-img cover-background dark-overlay"
          data-overlay-dark="75"
          style={{ backgroundImage: "url('/assets/img/home/slide-index-hot-sale.jpg')" }}
        >
          <div className="container d-flex flex-column">
            <div className="row align-items-center min-vh-100 pt-6 pt-md-0">
              <div className="col-md-11 col-lg-9 col-xl-8 col-xxl-7 mb-1-9 mb-lg-0 pt-6 pb-12 py-sm-6">
                <div className="banner-title1">
                  <div className="d-flex align-items-center">
                    <h1 className="mb-0 font-weight-700 lh-1 text-shadow">Piso LVT, </h1> 
                    <div className="ms-3 d-none d-sm-inline-block">
                      <img
                        src="/assets/img/home/slide-logo-small-home.jpg"
                        alt="Decototal - Recubrimientos para muros y pisos"
                        className="rounded-pill"
                      />
                    </div>
                  </div>
                  <div className="fst-italic font-weight-800 h1 mb-0 lh-1 text-shadow"> similar a la madera </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Slide 2 */}
        <div
          className="item bg-img cover-background dark-overlay"
          data-overlay-dark="75"
          style={{ backgroundImage: "url('/assets/img/home/slide-index-hot-sale-lambrin.jpg')" }}
        >
          <div className="container d-flex flex-column">
            <div className="row align-items-center min-vh-100 pt-6 pt-md-0">
              <div className="col-md-11 col-lg-9 col-xl-8 col-xxl-7 mb-1-9 mb-lg-0 pt-6 pb-12 py-sm-6">
                <div className="banner-title1">
                  <div className="d-flex align-items-center">
                    <h1 className="mb-0 font-weight-700 lh-1 text-shadow">Lambrín Cóncavo</h1>
                    <div className="ms-3 d-none d-sm-inline-block">
                      <img
                        src="/assets/img/home/slide-logo-small-home.jpg"
                        alt="Decototal - Recubrimientos para muros y pisos"
                        className="rounded-pill"
                      />
                    </div>
                  </div>
                  <div className="fst-italic font-weight-800 h1 mb-0 lh-1 text-shadow">Para interiores</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Slide 3 */}
        <div
          className="item bg-img cover-background dark-overlay"
          data-overlay-dark="75"
          style={{ backgroundImage: "url('/assets/img/home/slide-index-contenedor.jpg')" }}
        >
          <div className="container d-flex flex-column">
            <div className="row align-items-center min-vh-100 pt-6 pt-md-0">
              <div className="col-md-11 col-lg-9 col-xl-8 col-xxl-7 mb-1-9 mb-lg-0 pt-6 pb-12 py-sm-6">
                <div className="banner-title1">
                  <div className="d-flex align-items-center">
                    <h1 className="mb-0 font-weight-700 lh-1 text-shadow">Contamos con Entrega</h1>
                    <div className="ms-3 d-none d-sm-inline-block">
                      <img
                        src="/assets/img/home/slide-logo-small-home.jpg"
                        alt="Amplio stock en bodega"
                        className="rounded-pill"
                      />
                    </div>
                  </div>
                  <div className="fst-italic font-weight-800 h1 mb-0 lh-1 text-shadow">Inmediata</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SliderHome;
